(() => {
  'use strict';

  let frameId = 0;
  let observedDrawer = null;
  let drawerObserver = null;

  function scheduleMove() {
    if (frameId) return;
    frameId = window.requestAnimationFrame(moveFreeShippingBar);
  }

  function observeDrawer(drawer) {
    if (observedDrawer === drawer) return;

    drawerObserver?.disconnect();
    observedDrawer = drawer;
    drawerObserver = new MutationObserver(scheduleMove);
    drawerObserver.observe(drawer, { childList: true, subtree: true });
  }

  function moveFreeShippingBar() {
    frameId = 0;

    const drawer = document.querySelector('#t4s-mini_cart');
    if (!drawer) return;

    observeDrawer(drawer);

    const form = drawer.querySelector('#t4s-tab-minicart');
    const main = form?.querySelector('.t4s-drawer__main');
    const bar = drawer.querySelector('[data-cart-calc-shipping]');

    if (!form || !main || !bar) return;

    bar.classList.add('jd1-free-shipping-top');

    if (bar.parentElement !== form || bar.nextElementSibling !== main) {
      form.insertBefore(bar, main);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMove, { once: true });
  } else {
    scheduleMove();
  }

  document.addEventListener('cart:updated', scheduleMove);
  document.addEventListener('shopify:section:load', scheduleMove);
  window.setTimeout(scheduleMove, 300);
  window.setTimeout(scheduleMove, 1000);
})();
